exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.orange-error--text {\n  color: #fd9a00 !important;\n}\n", ""]);

// exports
